/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CurrencyCode } from "./CurrencyCode";
import {
  CurrencyCodeFromJSON,
  CurrencyCodeFromJSONTyped,
  CurrencyCodeToJSON,
  CurrencyCodeToJSONTyped,
} from "./CurrencyCode";
import type { AdditionalCarrierFee } from "./AdditionalCarrierFee";
import {
  AdditionalCarrierFeeFromJSON,
  AdditionalCarrierFeeFromJSONTyped,
  AdditionalCarrierFeeToJSON,
  AdditionalCarrierFeeToJSONTyped,
} from "./AdditionalCarrierFee";

/**
 *
 * @export
 * @interface QuoteTestResult
 */
export interface QuoteTestResult {
  /**
   *
   * @type {number}
   * @memberof QuoteTestResult
   */
  quotedPriceByCarrierCad?: number;
  /**
   *
   * @type {number}
   * @memberof QuoteTestResult
   */
  quotedPriceByCarrierCadWithoutTax?: number;
  /**
   *
   * @type {number}
   * @memberof QuoteTestResult
   */
  quotedPriceByCarrierOriginalCurrency?: number;
  /**
   *
   * @type {CurrencyCode}
   * @memberof QuoteTestResult
   */
  originalCurrency?: CurrencyCode;
  /**
   *
   * @type {number}
   * @memberof QuoteTestResult
   */
  additionalCarrierFeesCad?: number;
  /**
   *
   * @type {string}
   * @memberof QuoteTestResult
   */
  additionalCarrierFeesNotes?: string;
  /**
   *
   * @type {boolean}
   * @memberof QuoteTestResult
   */
  includesTax?: boolean;
  /**
   *
   * @type {string}
   * @memberof QuoteTestResult
   */
  customerPriceExplanation?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestResult
   */
  carrierPriceExplanationInternal?: string;
  /**
   *
   * @type {string}
   * @memberof QuoteTestResult
   */
  carrierPriceExplanationExternal?: string;
  /**
   *
   * @type {Array<AdditionalCarrierFee>}
   * @memberof QuoteTestResult
   */
  additionalCarrierFees?: Array<AdditionalCarrierFee>;
  /**
   *
   * @type {string}
   * @memberof QuoteTestResult
   */
  loadingDiagramSvg?: string;
}

/**
 * Check if a given object implements the QuoteTestResult interface.
 */
export function instanceOfQuoteTestResult(
  value: object,
): value is QuoteTestResult {
  return true;
}

export function QuoteTestResultFromJSON(json: any): QuoteTestResult {
  return QuoteTestResultFromJSONTyped(json, false);
}

export function QuoteTestResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteTestResult {
  if (json == null) {
    return json;
  }
  return {
    quotedPriceByCarrierCad:
      json["quotedPriceByCarrierCad"] == null
        ? undefined
        : json["quotedPriceByCarrierCad"],
    quotedPriceByCarrierCadWithoutTax:
      json["quotedPriceByCarrierCadWithoutTax"] == null
        ? undefined
        : json["quotedPriceByCarrierCadWithoutTax"],
    quotedPriceByCarrierOriginalCurrency:
      json["quotedPriceByCarrierOriginalCurrency"] == null
        ? undefined
        : json["quotedPriceByCarrierOriginalCurrency"],
    originalCurrency:
      json["originalCurrency"] == null
        ? undefined
        : CurrencyCodeFromJSON(json["originalCurrency"]),
    additionalCarrierFeesCad:
      json["additionalCarrierFeesCad"] == null
        ? undefined
        : json["additionalCarrierFeesCad"],
    additionalCarrierFeesNotes:
      json["additionalCarrierFeesNotes"] == null
        ? undefined
        : json["additionalCarrierFeesNotes"],
    includesTax: json["includesTax"] == null ? undefined : json["includesTax"],
    customerPriceExplanation:
      json["customerPriceExplanation"] == null
        ? undefined
        : json["customerPriceExplanation"],
    carrierPriceExplanationInternal:
      json["carrierPriceExplanationInternal"] == null
        ? undefined
        : json["carrierPriceExplanationInternal"],
    carrierPriceExplanationExternal:
      json["carrierPriceExplanationExternal"] == null
        ? undefined
        : json["carrierPriceExplanationExternal"],
    additionalCarrierFees:
      json["additionalCarrierFees"] == null
        ? undefined
        : (json["additionalCarrierFees"] as Array<any>).map(
            AdditionalCarrierFeeFromJSON,
          ),
    loadingDiagramSvg:
      json["loadingDiagramSvg"] == null ? undefined : json["loadingDiagramSvg"],
  };
}

export function QuoteTestResultToJSON(json: any): QuoteTestResult {
  return QuoteTestResultToJSONTyped(json, false);
}

export function QuoteTestResultToJSONTyped(
  value?: QuoteTestResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    quotedPriceByCarrierCad: value["quotedPriceByCarrierCad"],
    quotedPriceByCarrierCadWithoutTax:
      value["quotedPriceByCarrierCadWithoutTax"],
    quotedPriceByCarrierOriginalCurrency:
      value["quotedPriceByCarrierOriginalCurrency"],
    originalCurrency: CurrencyCodeToJSON(value["originalCurrency"]),
    additionalCarrierFeesCad: value["additionalCarrierFeesCad"],
    additionalCarrierFeesNotes: value["additionalCarrierFeesNotes"],
    includesTax: value["includesTax"],
    customerPriceExplanation: value["customerPriceExplanation"],
    carrierPriceExplanationInternal: value["carrierPriceExplanationInternal"],
    carrierPriceExplanationExternal: value["carrierPriceExplanationExternal"],
    additionalCarrierFees:
      value["additionalCarrierFees"] == null
        ? undefined
        : (value["additionalCarrierFees"] as Array<any>).map(
            AdditionalCarrierFeeToJSON,
          ),
    loadingDiagramSvg: value["loadingDiagramSvg"],
  };
}
